import { defineMessages } from 'react-intl';

export default defineMessages({
    remove: {
        id: 'ml.agent.quoteandbind.pa.drivers.removedriver.Remove Driver',
        defaultMessage: 'Remove Driver'
    },
    relationshipToInsured: {
        id: 'ml.agent.quoteandbind.pa.drivers.removedriver.RelationshipToInsured',
        defaultMessage: 'Relationship to Insured'
    },
    reason: {
        id: 'ml.agent.quoteandbind.pa.drivers.removedriver.Reason',
        defaultMessage: 'Reason'
    },
    Continue: {
        id: 'ml.agent.quoteandbind.pa.drivers.removedriver.Continue',
        defaultMessage: 'CONTINUE'
    },
    Cancel: {
        id: 'ml.agent.quoteandbind.pa.drivers.removedriver.Cancel',
        defaultMessage: 'CANCEL'
    },
    DriverHasBeenRemoved: {
        id: 'ml.agent.quoteandbind.pa.views.drivers.Driver has been removed.',
        defaultMessage: 'has been removed.'
    },
    DriverHasBeenAddedAsAHouseHoldMember: {
        id: 'ml.agent.quoteandbind.pa.views.drivers.Driver has been added as a household member.',
        defaultMessage: 'has been added as a household member.'
    },
    DriverHasBeenAddedAsANonDriver: {
        id: 'ml.agent.quoteandbind.pa.views.drivers.Driver has been added as a non driver.',
        defaultMessage: 'has been added as a non driver.'
    },
    DriverHasBeenExcluded: {
        id: 'ml.agent.quoteandbind.pa.views.drivers.Driver has been excluded and will not be covered.',
        defaultMessage: 'has been excluded and will not be covered.'
    },
    RemoveDriverExclusionHelpTitle: {
        id: 'ml.agent.quoteandbind.pa.views.drivers.Title',
        defaultMessage: 'The driver must be either rated or excluded on this policy.'
    },
    RemoveDriverExclusionHelpText: {
        id: 'ml.agent.quoteandbind.pa.views.drivers.Text',
        defaultMessage: 'The reason selected is not a valid reason to remove a driver.  If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy.'
    },
    notAValidReasonToRemoveThisDriver_Ext: {
        id: 'ml.agent.quoteandbind.pa.views.The reason selected is not a valid reason to remove this driver.  We require this person to be listed as a driver.',
        defaultMessage: 'The reason selected is not a valid reason to remove this driver.  We require this person to be listed as a driver.'
    }
});